module.exports = __webpack_public_path__ + "img/section_nescafe_classic.240713c3.png";